const PLAYER_ERRORS = {
  UNABLE_TO_RECOVER: 'Unable to recover player error.',
  NO_SOURCE: 'There is no video source available',
};

export default PLAYER_ERRORS;
